
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8woNY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $jC4nA = parcelRequire("jC4nA");


var $lpNn5 = parcelRequire("lpNn5");


var $9DHhW = parcelRequire("9DHhW");


var $hdBxM = parcelRequire("hdBxM");


var $d5gEx = parcelRequire("d5gEx");


var $bQm3c = parcelRequire("bQm3c");


var $lsxnT = parcelRequire("lsxnT");
















function $a6cd48ac30899c1c$export$e70e6da722faba05(e, u, c, i) {
    var a = this, o = (0, $cozmU.useRef)(null), f = (0, $cozmU.useRef)(0), l = (0, $cozmU.useRef)(0), v = (0, $cozmU.useRef)(null), m = (0, $cozmU.useRef)([]), d = (0, $cozmU.useRef)(), g = (0, $cozmU.useRef)(), p = (0, $cozmU.useRef)(e), w = (0, $cozmU.useRef)(!0);
    p.current = e;
    var s = "undefined" != typeof window, x = !u && 0 !== u && s;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    u = +u || 0;
    var h = !!(c = c || {}).leading, y = !("trailing" in c) || !!c.trailing, F = "maxWait" in c, A = "debounceOnServer" in c && !!c.debounceOnServer, D = F ? Math.max(+c.maxWait || 0, u) : null;
    (0, $cozmU.useEffect)(function() {
        return w.current = !0, function() {
            w.current = !1;
        };
    }, []);
    var T = (0, $cozmU.useMemo)(function() {
        var r = function(r) {
            var n = m.current, t = d.current;
            return m.current = d.current = null, f.current = r, l.current = l.current || r, g.current = p.current.apply(t, n);
        }, n = function(r, n) {
            x && cancelAnimationFrame(v.current), v.current = x ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!w.current) return !1;
            var n = r - o.current;
            return !o.current || n >= u || n < 0 || F && r - f.current >= D;
        }, e = function(n) {
            return v.current = null, y && m.current ? r(n) : (m.current = d.current = null, g.current);
        }, c = function r() {
            var c = Date.now();
            if (h && l.current === f.current && T(), t(c)) return e(c);
            if (w.current) {
                var i = u - (c - o.current), a = F ? Math.min(i, D - (c - f.current)) : i;
                n(r, a);
            }
        }, T = function() {
            i && i({});
        }, W = function() {
            if (s || A) {
                var e = Date.now(), i = t(e);
                if (m.current = [].slice.call(arguments), d.current = a, o.current = e, i) {
                    if (!v.current && w.current) return f.current = o.current, n(c, u), h ? r(o.current) : g.current;
                    if (F) return n(c, u), r(o.current);
                }
                return v.current || n(c, u), g.current;
            }
        };
        return W.cancel = function() {
            v.current && (x ? cancelAnimationFrame(v.current) : clearTimeout(v.current)), f.current = 0, m.current = o.current = d.current = v.current = null;
        }, W.isPending = function() {
            return !!v.current;
        }, W.flush = function() {
            return v.current ? e(Date.now()) : g.current;
        }, W;
    }, [
        h,
        F,
        u,
        D,
        y,
        x,
        s,
        A,
        i
    ]);
    return T;
}
function $a6cd48ac30899c1c$var$i(r, n) {
    return r === n;
}
function $a6cd48ac30899c1c$export$21805fee57372823(n, t, a) {
    var o = a && a.equalityFn || $a6cd48ac30899c1c$var$i, f = (0, $cozmU.useRef)(n), l = (0, $cozmU.useState)({})[1], v = $a6cd48ac30899c1c$export$e70e6da722faba05((0, $cozmU.useCallback)(function(r) {
        f.current = r, l({});
    }, [
        l
    ]), t, a, l), m = (0, $cozmU.useRef)(n);
    return o(m.current, n) || (v(n), m.current = n), [
        f.current,
        v
    ];
}
function $a6cd48ac30899c1c$export$7158785e55df0693(r, n, t) {
    var e = void 0 === t ? {} : t, u = e.leading, i = e.trailing;
    return $a6cd48ac30899c1c$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === u || u,
        trailing: void 0 === i || i
    });
}
 //# sourceMappingURL=index.module.js.map






var $gFEZF = parcelRequire("gFEZF");





var $hAgam = parcelRequire("hAgam");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $eKpjD = parcelRequire("eKpjD");


var $5hJlu = parcelRequire("5hJlu");


var $lfoFx = parcelRequire("lfoFx");


var $4yg9g = parcelRequire("4yg9g");


var $3z1p5 = parcelRequire("3z1p5");


var $3ay5Z = parcelRequire("3ay5Z");


var $fa8WQ = parcelRequire("fa8WQ");


var $eP6A1 = parcelRequire("eP6A1");


var $87k0g = parcelRequire("87k0g");


var $jW2nL = parcelRequire("jW2nL");




const $b57bfe8ffb391986$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    heading: {
        id: "object-sidebar-components.confluence-agent-menu.heading",
        defaultMessage: "Select an agent"
    },
    searchPlaceholder: {
        id: "object-sidebar-components.confluence-agent-menu.search-placeholder",
        defaultMessage: "Search agents"
    },
    favoriteSection: {
        id: "object-sidebar-components.confluence-agent-menu.favorite-section",
        defaultMessage: "Favorite"
    },
    recommendedSection: {
        id: "object-sidebar-components.confluence-agent-menu.recommended-section",
        defaultMessage: "Recommended"
    },
    browseAgents: {
        id: "object-sidebar-components.confluence-agent-menu.browse-agents",
        defaultMessage: "Browse agents"
    },
    createAgent: {
        id: "object-sidebar-components.confluence-agent-menu.create-agent",
        defaultMessage: "Create agent"
    },
    noAgentsFound: {
        id: "object-sidebar-components.confluence-agent-menu.no-agents-found",
        defaultMessage: "No agents found"
    },
    loading: {
        id: "object-sidebar-components.confluence-agent-menu.loading",
        defaultMessage: "Loading agents"
    },
    loadingError: {
        id: "object-sidebar-components.confluence-agent-menu.loading-error",
        defaultMessage: "Failed to load agents. Please try again."
    }
});


// to avoid @compiled/react styled limitations with child selectors
const $7cd95e95dfcaa223$var$TextfieldInputWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            display: "flex",
            flexDirection: "column",
            width: "100%"
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }
    }, children);
// Debounce delay (ms) for server-side agent search as the user types.
const $7cd95e95dfcaa223$var$SEARCH_DEBOUNCE_MS = 400; // Known Atlassian Studio origins allowed for the "Create agent" deep link.
// Validated in handleCreateAgent to prevent potential open redirect or XSS vectors.
const $7cd95e95dfcaa223$var$ALLOWED_STUDIO_ORIGINS = [
    'https://studio.atlassian.com',
    'https://atlassian-studio.stg-east.frontend.public.atl-paas.net'
];
const $7cd95e95dfcaa223$var$styles = {
    heading: "_0Of8r28HPE _1wydGW1Y8M _2Zuz6Q8HPE _1Znuxb8HPE _0KLXruoI2d",
    loadingWrapper: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0Of8r25zaO _1wydGW5zaO",
    errorWrapper: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE",
    searchWrapper: "_3iDTPbQ4SZ _0Of8r21Y8M _1ZnuxbgVvo _1wydGW2ADO _2Zuz6QgVvo _0aFT5vbt8w _4xdlr0FlnN",
    emptySection: "_2Zuz6Q8HPE _1Znuxb8HPE _0Of8r21Y8M _1wydGW1Y8M",
    profileCardTriggerWrapper: "_3iDTPbvLZJ _39xV02N91d"
};
const $7cd95e95dfcaa223$var$AgentSearchInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(6);
    const { value: value, onChange: onChange, placeholder: placeholder } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: ""
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onChange || $[2] !== placeholder || $[3] !== ref || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7cd95e95dfcaa223$var$styles.searchWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cd95e95dfcaa223$var$TextfieldInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ref: ref,
            value: value,
            onChange: onChange,
            placeholder: placeholder,
            testId: "confluence-agent-menu-search-input",
            elemBeforeInput: t1
        })));
        $[1] = onChange;
        $[2] = placeholder;
        $[3] = ref;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ value: value, onChange: onChange, placeholder: placeholder }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7cd95e95dfcaa223$var$styles.searchWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cd95e95dfcaa223$var$TextfieldInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        ref: ref,
        value: value,
        onChange: onChange,
        placeholder: placeholder,
        testId: "confluence-agent-menu-search-input",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: ""
        }))
    }))));
$7cd95e95dfcaa223$var$AgentSearchInput.displayName = 'AgentSearchInput';
const $7cd95e95dfcaa223$var$AgentItem = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { agent: agent, isSelected: isSelected, onSelect: onSelect, onFavoriteToggle: onFavoriteToggle, cloudId: cloudId, profileClient: profileClient } = t0;
    let t1;
    if ($[0] !== agent || $[1] !== onSelect) {
        t1 = ()=>{
            onSelect(agent);
        };
        $[0] = agent;
        $[1] = onSelect;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    let t2;
    if ($[3] !== agent || $[4] !== onFavoriteToggle) {
        t2 = ()=>{
            onFavoriteToggle?.(agent);
        };
        $[3] = agent;
        $[4] = onFavoriteToggle;
        $[5] = t2;
    } else t2 = $[5];
    const handleFavoriteClick = t2;
    const t3 = agent.name;
    let t4;
    if ($[6] !== agent) {
        t4 = (0, $eP6A1.getAgentIcon)(agent);
        $[6] = agent;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = onFavoriteToggle ? handleFavoriteClick : undefined;
    const t6 = `confluence-agent-menu-agent-item-${agent.id}`;
    let t7;
    if ($[8] !== agent.favourite || $[9] !== agent.is_verified || $[10] !== agent.name || $[11] !== handleClick || $[12] !== isSelected || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
            label: t3,
            icon: t4,
            onClick: handleClick,
            isActive: isSelected,
            isFavorite: agent.favourite,
            isVerified: agent.is_verified,
            onFavoriteClick: t5,
            testId: t6
        });
        $[8] = agent.favourite;
        $[9] = agent.is_verified;
        $[10] = agent.name;
        $[11] = handleClick;
        $[12] = isSelected;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    const menuItem = t7;
    if (!agent.identity_account_id) return menuItem;
    let t8;
    if ($[17] !== agent.id || $[18] !== cloudId || $[19] !== handleClick || $[20] !== menuItem || $[21] !== profileClient) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7cd95e95dfcaa223$var$styles.profileCardTriggerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKpjD.AgentProfileCardTrigger), {
            trigger: "hover",
            agentId: agent.id,
            resourceClient: profileClient,
            cloudId: cloudId,
            hideStarButton: true,
            onChatClick: handleClick,
            onConversationStartersClick: handleClick
        }, menuItem));
        $[17] = agent.id;
        $[18] = cloudId;
        $[19] = handleClick;
        $[20] = menuItem;
        $[21] = profileClient;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ agent: agent, isSelected: isSelected, onSelect: onSelect, onFavoriteToggle: onFavoriteToggle, cloudId: cloudId, profileClient: profileClient })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(agent);
    }, [
        agent,
        onSelect
    ]);
    const handleFavoriteClick = (0, $cozmU.useCallback)(()=>{
        onFavoriteToggle?.(agent);
    }, [
        agent,
        onFavoriteToggle
    ]);
    const menuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
        label: agent.name,
        icon: (0, $eP6A1.getAgentIcon)(agent),
        onClick: handleClick,
        isActive: isSelected,
        isFavorite: agent.favourite,
        isVerified: agent.is_verified,
        onFavoriteClick: onFavoriteToggle ? handleFavoriteClick : undefined,
        testId: `confluence-agent-menu-agent-item-${agent.id}`
    }); // Agents without a directory identity (e.g. some system/default agents) don't have
    // profile data to show — fall back to the plain item, matching AgentDropdownItem's
    // established pattern for the same profile card component elsewhere in the codebase.
    if (!agent.identity_account_id) return menuItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7cd95e95dfcaa223$var$styles.profileCardTriggerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKpjD.AgentProfileCardTrigger), {
        trigger: "hover",
        agentId: agent.id,
        resourceClient: profileClient,
        cloudId: cloudId,
        hideStarButton: true,
        onChatClick: handleClick,
        onConversationStartersClick: handleClick
    }, menuItem));
};
const $7cd95e95dfcaa223$var$MAX_FAVORITE_AGENTS = 5;
const $7cd95e95dfcaa223$export$217d0d71c0efbfc6 = ({ cloudId: cloudId, selectedAgentId: selectedAgentId, onSelectAgent: onSelectAgent, onBrowseAgents: onBrowseAgents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [searchInputValue, setSearchInputValue] = (0, $cozmU.useState)('');
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const searchInputRef = (0, $cozmU.useRef)(null); // Focus search on mount
    (0, $cozmU.useEffect)(()=>{
        searchInputRef.current?.focus();
    }, []);
    const assistanceServiceParams = (0, $cozmU.useMemo)(()=>({
            touchpointSource: 'confluence-object-sidebar-agents-button',
            product: 'confluence',
            experienceId: 'ai-mate',
            siteId: cloudId,
            baseUrl: `/gateway/api/assist`
        }), [
        cloudId
    ]); // Client for the agent hover preview card (AgentProfileCardTrigger) — shows agent
    // details (description, verified badge, conversation starters) on hover, mirroring
    // the same pattern used by AgentDropdownItem elsewhere in the AI Mate codebase.
    const profileClient = (0, $cozmU.useMemo)(()=>new (0, $5hJlu.ProfileClient)({
            url: '/gateway/api/directory/graphql',
            productIdentifier: 'rovo',
            cloudId: cloudId
        }), [
        cloudId
    ]); // Fetch recommended agents
    const { recommendedAgents: recommendedAgents } = (0, $3z1p5.useRecommendedAgents)({
        assistanceServiceParams: assistanceServiceParams
    }); // Defensive snapshot: `recommendedAgents` is expected to be a stable, one-time fetch for
    // the whole session (limit/pageUrl/siteId never change, and the underlying agent records
    // are never removed from the shared store) — but has been observed in practice to lose
    // entries after a favourite-then-unfavourite round trip, causing the Recommended section
    // to disappear and never recover (a full page reload does bring it back, which points to
    // something upstream in the shared platform store/cache rather than in this component).
    // Since the raw list is meant to be static anyway, we only ever grow this snapshot —
    // never let it shrink — so a transient upstream data loss can't hide the section from
    // under the user for the rest of the session. The seen-map is mutated during render (a
    // standard idempotent memoization pattern) rather than via an effect, since new ids are
    // only ever added and re-running this for the same input is a no-op.
    const seenRecommendedAgentsRef = (0, $cozmU.useRef)(new Map());
    const stableRecommendedAgents = (0, $cozmU.useMemo)(()=>{
        for (const agent of recommendedAgents)if (!seenRecommendedAgentsRef.current.has(agent.id)) seenRecommendedAgentsRef.current.set(agent.id, agent);
        return Array.from(seenRecommendedAgentsRef.current.values());
    }, [
        recommendedAgents
    ]); // Fetch starred agents for favorites section
    const [{ agentsByCategory: starredAgents, isCategoryLoading: isStarredLoading }] = (0, $3z1p5.usePaginatedAgentsByCategory)('starred-agents'); // Fetch all agents for search
    const [{ agentsByCategory: allAgentsList, isCategoryLoading: isAllAgentsLoading, agentsError: agentsError }] = (0, $3z1p5.usePaginatedAgentsByCategory)('all-agents');
    const { fetchAgentsByCategory: fetchAgentsByCategory, populateAgentCategories: populateAgentCategories } = (0, $3z1p5.usePaginatedAgentsActions)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceParams
    }); // Local optimistic overrides for favourite state, keyed by agent id. The server-fetched
    // agent lists (starred/recommended/all) don't reflect a toggle until the categories are
    // refetched, so we track pending overrides — including a snapshot of the agent itself —
    // to flip the star instantly and move the agent in/out of the Favorites section without
    // waiting on (or triggering) a network refetch.
    const [favoriteOverrides, setFavoriteOverrides] = (0, $cozmU.useState)({}); // Deliberately do NOT trust the `favourite` field on agent objects coming from
    // endpoints other than starred-agents (e.g. recommended-agents) — agent records are
    // deduped through a shared, page-level store (usePaginatedAgentsMap) keyed by id, and
    // that field can be stale/inconsistent across endpoints. starred-agents category
    // membership (adjusted by our optimistic overrides) is the single source of truth.
    const favoriteAgentIds = (0, $cozmU.useMemo)(()=>{
        const ids = new Set((starredAgents ?? []).map((agent_0)=>agent_0.id));
        for (const [id, { favourite: favourite }] of Object.entries(favoriteOverrides))if (favourite) ids.add(id);
        else ids.delete(id);
        return ids;
    }, [
        starredAgents,
        favoriteOverrides
    ]); // Stabilize fetchAgentsByCategory and populateAgentCategories via refs
    // to avoid stale closure issues in useEffect — same pattern used by AgentMenu.
    const fetchAgentsByCategoryRef = (0, $cozmU.useRef)(fetchAgentsByCategory);
    const populateAgentCategoriesRef = (0, $cozmU.useRef)(populateAgentCategories);
    (0, $cozmU.useEffect)(()=>{
        fetchAgentsByCategoryRef.current = fetchAgentsByCategory;
    }, [
        fetchAgentsByCategory
    ]);
    (0, $cozmU.useEffect)(()=>{
        populateAgentCategoriesRef.current = populateAgentCategories;
    }, [
        populateAgentCategories
    ]); // Debounced server-side search (same pattern as rovo-ai-search's CarouselComponent).
    const debouncedSetSearchQuery = (0, $a6cd48ac30899c1c$export$e70e6da722faba05)((value)=>{
        setSearchQuery(value);
    }, $7cd95e95dfcaa223$var$SEARCH_DEBOUNCE_MS); // Load agents when searchQuery changes (server-side search)
    (0, $cozmU.useEffect)(()=>{
        if (!searchQuery) fetchAgentsByCategoryRef.current({
            category: 'starred-agents',
            query: ''
        });
        fetchAgentsByCategoryRef.current({
            category: 'all-agents',
            query: searchQuery
        });
        return ()=>{
            populateAgentCategoriesRef.current({
                category: 'starred-agents',
                agentsList: [],
                pageInfo: {
                    startCursor: undefined,
                    endCursor: undefined,
                    hasNextPage: false,
                    hasPreviousPage: false
                }
            });
            populateAgentCategoriesRef.current({
                category: 'all-agents',
                agentsList: [],
                pageInfo: {
                    startCursor: undefined,
                    endCursor: undefined,
                    hasNextPage: false,
                    hasPreviousPage: false
                }
            });
        };
    }, [
        searchQuery
    ]);
    const favoriteAgents = (0, $cozmU.useMemo)(()=>{
        // Cap only the server-confirmed portion of the list. Applying MAX_FAVORITE_AGENTS to
        // the combined (pending + base) list would silently evict an item on every toggle:
        // prepending pending items would push an existing starred agent out of view, while
        // appending them would push the just-favourited agent out of view — and since it's
        // already excluded from Recommended/Search via favoriteAgentIds, that would make it
        // disappear from the menu entirely. Letting the list temporarily exceed the cap by a
        // couple of items (until the next natural refetch settles it) is the better trade-off.
        const base = [];
        for (const agent_1 of starredAgents ?? [])if (favoriteAgentIds.has(agent_1.id)) {
            base.push(agent_1);
            if (base.length >= $7cd95e95dfcaa223$var$MAX_FAVORITE_AGENTS) break;
        }
        const baseIds = new Set(base.map((agent_2)=>agent_2.id)); // Agents optimistically favourited (e.g. from Recommended/Search) that the server
        // hasn't returned in the starred-agents category yet — surface them immediately so
        // the agent shows up in Favorites without waiting on a refetch.
        const pendingAdditions = [];
        for (const { favourite: favourite_0, agent: agent_3 } of Object.values(favoriteOverrides))if (favourite_0 && !baseIds.has(agent_3.id)) pendingAdditions.push(agent_3);
        return [
            ...pendingAdditions,
            ...base
        ].map((agent_4)=>({
                ...agent_4,
                favourite: true
            }));
    }, [
        starredAgents,
        favoriteOverrides,
        favoriteAgentIds
    ]);
    const filteredRecommendedAgents = (0, $cozmU.useMemo)(()=>{
        // Exclude agents already in favorites, and force `favourite: false` on the rest —
        // this list is defined as "not favourited", so we never trust the raw field here
        // (see favoriteAgentIds comment above for why it can't be trusted). Use the sticky
        // snapshot (see `stableRecommendedAgents` above) rather than `recommendedAgents`
        // directly, so a favourite/unfavourite round trip can't make an agent vanish.
        const result = [];
        for (const agent_5 of stableRecommendedAgents)if (!favoriteAgentIds.has(agent_5.id)) result.push({
            ...agent_5,
            favourite: false
        });
        return result;
    }, [
        stableRecommendedAgents,
        favoriteAgentIds
    ]); // Search results come from server-side filtered all-agents category
    const filteredAgents = (0, $cozmU.useMemo)(()=>{
        if (!searchQuery.trim()) return null; // null = not in search mode
        return (allAgentsList ?? []).map((agent_6)=>({
                ...agent_6,
                favourite: favoriteAgentIds.has(agent_6.id)
            }));
    }, [
        searchQuery,
        allAgentsList,
        favoriteAgentIds
    ]);
    const handleSelectAgent = (0, $cozmU.useCallback)((agent_7)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'agent',
                source: 'confluenceObjectSidebarAgentsMenu',
                attributes: {
                    agentId: agent_7.id
                }
            }
        }).fire();
        onSelectAgent(agent_7);
    }, [
        onSelectAgent,
        createAnalyticsEvent
    ]);
    const handleFavoriteToggle = (0, $cozmU.useCallback)((agent_8)=>{
        const isFavorited = !favoriteAgentIds.has(agent_8.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'favoriteAgent',
                source: 'confluenceObjectSidebarAgentsMenu',
                attributes: {
                    agentId: agent_8.id,
                    isFavorited: isFavorited
                }
            }
        }).fire(); // Optimistically flip the star and move the agent in/out of the Favorites
        // section immediately. Deliberately *not* triggering a fetchAgentsByCategory
        // refetch here — that flips the shared `isCategoryLoading` flag and collapses
        // the whole menu (Favorites + Recommended) down to a single spinner. The local
        // override above already keeps everything in sync for the current session.
        setFavoriteOverrides((prev)=>({
                ...prev,
                [agent_8.id]: {
                    favourite: isFavorited,
                    agent: agent_8
                }
            }));
        const callbacks = {
            onError: ()=>{
                setFavoriteOverrides((prev_0)=>({
                        ...prev_0,
                        [agent_8.id]: {
                            favourite: !isFavorited,
                            agent: agent_8
                        }
                    }));
            }
        };
        if (isFavorited) favouriteAgent.mutate(agent_8.id, callbacks);
        else unfavouriteAgent.mutate(agent_8.id, callbacks);
    }, [
        favoriteAgentIds,
        createAnalyticsEvent,
        favouriteAgent,
        unfavouriteAgent
    ]);
    const createAgentUrl = (0, $cozmU.useMemo)(()=>(0, $fa8WQ.getAtlassianStudioNLCreateUrl)(cloudId, 'confluence-object-sidebar'), [
        cloudId
    ]);
    const handleBrowseAgents = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'browseAgents',
                source: 'confluenceObjectSidebarAgentsMenu'
            }
        }).fire();
        onBrowseAgents();
    }, [
        onBrowseAgents,
        createAnalyticsEvent
    ]);
    const handleSearchChange = (0, $cozmU.useCallback)((e)=>{
        setSearchInputValue(e.target.value);
        debouncedSetSearchQuery(e.target.value);
    }, [
        debouncedSetSearchQuery
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createAgent',
                source: 'confluenceObjectSidebarAgentsMenu'
            }
        }).fire(); // Validate URL is a known Atlassian Studio domain before opening
        // to prevent potential open redirect or XSS vectors
        try {
            const url = new URL(createAgentUrl);
            const isAllowedOrigin = $7cd95e95dfcaa223$var$ALLOWED_STUDIO_ORIGINS.some((allowed)=>url.origin === new URL(allowed).origin);
            if (isAllowedOrigin) window.open(createAgentUrl, '_blank', 'noopener,noreferrer');
        } catch  {}
    }, [
        createAgentUrl,
        createAnalyticsEvent
    ]);
    const isSearchMode = filteredAgents !== null;
    const isLoading = isStarredLoading || isAllAgentsLoading;
    const searchComponent = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cd95e95dfcaa223$var$AgentSearchInput, {
            key: "search",
            ref: searchInputRef,
            value: searchInputValue,
            onChange: handleSearchChange,
            placeholder: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).searchPlaceholder)
        }), [
        searchInputValue,
        handleSearchChange,
        formatMessage
    ]);
    const footerItems = (0, $cozmU.useMemo)(()=>[
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                key: "browse-agents",
                label: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).browseAgents),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                    label: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).browseAgents),
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                onClick: handleBrowseAgents,
                testId: "confluence-agent-menu-browse-agents"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87k0g.MenuItem), {
                key: "create-agent",
                label: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).createAgent),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).createAgent),
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                onClick: handleCreateAgent,
                isExternalLink: true,
                testId: "confluence-agent-menu-create-agent"
            })
        ], [
        formatMessage,
        handleBrowseAgents,
        handleCreateAgent
    ]);
    const favoriteItems = (0, $cozmU.useMemo)(()=>favoriteAgents.map((agent_9)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cd95e95dfcaa223$var$AgentItem, {
                key: agent_9.id,
                agent: agent_9,
                isSelected: agent_9.id === selectedAgentId,
                onSelect: handleSelectAgent,
                onFavoriteToggle: handleFavoriteToggle,
                cloudId: cloudId,
                profileClient: profileClient
            })), [
        favoriteAgents,
        selectedAgentId,
        handleSelectAgent,
        handleFavoriteToggle,
        cloudId,
        profileClient
    ]);
    const recommendedItems = (0, $cozmU.useMemo)(()=>filteredRecommendedAgents.map((agent_10)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cd95e95dfcaa223$var$AgentItem, {
                key: agent_10.id,
                agent: agent_10,
                isSelected: agent_10.id === selectedAgentId,
                onSelect: handleSelectAgent,
                onFavoriteToggle: handleFavoriteToggle,
                cloudId: cloudId,
                profileClient: profileClient
            })), [
        filteredRecommendedAgents,
        selectedAgentId,
        handleSelectAgent,
        handleFavoriteToggle,
        cloudId,
        profileClient
    ]);
    const searchResultItems = (0, $cozmU.useMemo)(()=>{
        if (!isSearchMode) return null;
        if (filteredAgents.length === 0) return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: "empty",
                xcss: $7cd95e95dfcaa223$var$styles.emptySection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest"
            }, formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).noAgentsFound)))
        ];
        return filteredAgents.map((agent_11)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7cd95e95dfcaa223$var$AgentItem, {
                key: agent_11.id,
                agent: agent_11,
                isSelected: agent_11.id === selectedAgentId,
                onSelect: handleSelectAgent,
                onFavoriteToggle: handleFavoriteToggle,
                cloudId: cloudId,
                profileClient: profileClient
            }));
    }, [
        isSearchMode,
        filteredAgents,
        selectedAgentId,
        handleSelectAgent,
        handleFavoriteToggle,
        formatMessage,
        cloudId,
        profileClient
    ]);
    const loadingComponent = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: "loading",
            xcss: $7cd95e95dfcaa223$var$styles.loadingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            label: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).loading)
        })), [
        formatMessage
    ]);
    const errorComponent = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: "error",
            xcss: $7cd95e95dfcaa223$var$styles.errorWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).loadingError))), [
        formatMessage
    ]);
    const sections = (0, $cozmU.useMemo)(()=>{
        const result_0 = [
            {
                content: searchComponent
            },
            ...agentsError ? [
                {
                    content: errorComponent
                }
            ] : isLoading ? [
                {
                    content: loadingComponent
                }
            ] : isSearchMode ? filteredAgents?.length === 0 ? [
                {
                    content: searchResultItems
                }
            ] : [
                {
                    items: searchResultItems ?? []
                }
            ] : [
                ...favoriteItems.length > 0 ? [
                    {
                        title: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).favoriteSection),
                        items: favoriteItems
                    }
                ] : [],
                ...recommendedItems.length > 0 ? [
                    {
                        title: formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).recommendedSection),
                        items: recommendedItems
                    }
                ] : []
            ],
            {
                items: footerItems
            }
        ];
        return result_0.filter((section)=>'content' in section || section.items.length > 0);
    }, [
        searchComponent,
        agentsError,
        errorComponent,
        isLoading,
        loadingComponent,
        isSearchMode,
        searchResultItems,
        filteredAgents?.length,
        favoriteItems,
        recommendedItems,
        footerItems,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7cd95e95dfcaa223$var$styles.heading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        weight: "semibold",
        color: "color.text"
    }, formatMessage((0, $b57bfe8ffb391986$export$defe85febe8b728c).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jW2nL.ChatHeaderMenuList), {
        sections: sections
    }));
};


const $8b71c15dff7ca961$var$messages = (0, $kSwu1.defineMessages)({
    agentsPanelLabel: {
        id: "object-sidebar-components.agents-panel.label",
        defaultMessage: "Open Agents"
    },
    agentsPanelTooltip: {
        id: "object-sidebar-components.agents-panel.tooltip",
        defaultMessage: "Agents"
    }
});
const $8b71c15dff7ca961$export$2a2cb0aba834a686 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { contentId: contentId, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const publishRovo = (0, $hdBxM.usePublish)("ai-mate");
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [selectedAgentId, setSelectedAgentId] = (0, $cozmU.useState)(undefined);
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    let t2;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "agentsPanel",
                    source: "contentWrapper",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            setIsOpen($8b71c15dff7ca961$var$_temp);
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const handleOpen = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setIsOpen(false);
        };
        $[3] = t3;
    } else t3 = $[3];
    const handleClose = t3;
    let t4;
    if ($[4] !== publishRovo) {
        t4 = (agent)=>{
            if (!agent) return;
            setIsOpen(false);
            setSelectedAgentId(agent.id);
            try {
                publishRovo({
                    type: "chat-new",
                    source: "confluence-object-sidebar-agents-button",
                    openChat: true,
                    openChatMode: "mini-modal",
                    data: {
                        dialogues: [],
                        agentId: agent.id,
                        sourceId: `confluence-object-sidebar:agents-button:${agent.id}`,
                        mode: {
                            useCurrentPageContext: true
                        }
                    }
                });
            } catch (t5) {
                const e = t5;
            }
        };
        $[4] = publishRovo;
        $[5] = t4;
    } else t4 = $[5];
    const handleAgentSelect = t4;
    let t5;
    if ($[6] !== cloudId || $[7] !== handleAgentSelect || $[8] !== selectedAgentId) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cd95e95dfcaa223$export$217d0d71c0efbfc6), {
                cloudId: cloudId,
                selectedAgentId: selectedAgentId,
                onSelectAgent: handleAgentSelect,
                onBrowseAgents: handleClose
            });
        $[6] = cloudId;
        $[7] = handleAgentSelect;
        $[8] = selectedAgentId;
        $[9] = t5;
    } else t5 = $[9];
    const renderContent = t5;
    let t6;
    if ($[10] !== formatMessage || $[11] !== handleOpen || $[12] !== isDisabled || $[13] !== isOpen) {
        t6 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                position: "left",
                content: formatMessage($8b71c15dff7ca961$var$messages.agentsPanelTooltip),
                delay: 0,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                onClick: handleOpen,
                appearance: "subtle",
                shape: "default",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
                label: formatMessage($8b71c15dff7ca961$var$messages.agentsPanelLabel),
                testId: "sidebar-agents-button",
                isDisabled: isDisabled,
                isSelected: isOpen,
                interactionName: "open-agents-panel"
            }));
        $[10] = formatMessage;
        $[11] = handleOpen;
        $[12] = isDisabled;
        $[13] = isOpen;
        $[14] = t6;
    } else t6 = $[14];
    const renderTrigger = t6;
    if (!cloudId) return null;
    let t7;
    if ($[15] !== Popup || $[16] !== isOpen || $[17] !== renderContent || $[18] !== renderTrigger) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
            isOpen: isOpen,
            onClose: handleClose,
            placement: "left-start",
            content: renderContent,
            trigger: renderTrigger
        }));
        $[15] = Popup;
        $[16] = isOpen;
        $[17] = renderContent;
        $[18] = renderTrigger;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
} : ({ contentId: contentId, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const publishRovo = (0, $hdBxM.usePublish)('ai-mate');
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [selectedAgentId, setSelectedAgentId] = (0, $cozmU.useState)(undefined);
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const handleOpen = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'agentsPanel',
                source: 'contentWrapper',
                attributes: {
                    contentId: contentId
                }
            }
        }).fire();
        setIsOpen((prev)=>!prev);
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const handleAgentSelect = (0, $cozmU.useCallback)((agent)=>{
        if (!agent) return;
        setIsOpen(false);
        setSelectedAgentId(agent.id);
        try {
            publishRovo({
                type: 'chat-new',
                source: 'confluence-object-sidebar-agents-button',
                openChat: true,
                openChatMode: 'mini-modal',
                data: {
                    dialogues: [],
                    agentId: agent.id,
                    sourceId: `confluence-object-sidebar:agents-button:${agent.id}`,
                    mode: {
                        useCurrentPageContext: true
                    }
                }
            });
        } catch (e) {
        // Fail silently - popup is already closed
        }
    }, [
        publishRovo
    ]);
    const renderContent = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cd95e95dfcaa223$export$217d0d71c0efbfc6), {
            cloudId: cloudId,
            selectedAgentId: selectedAgentId,
            onSelectAgent: handleAgentSelect,
            onBrowseAgents: handleClose
        }), [
        cloudId,
        selectedAgentId,
        handleAgentSelect,
        handleClose
    ]);
    const renderTrigger = (0, $cozmU.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: formatMessage($8b71c15dff7ca961$var$messages.agentsPanelTooltip),
            delay: 0,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...triggerProps,
            onClick: handleOpen,
            appearance: "subtle",
            shape: "default",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: formatMessage($8b71c15dff7ca961$var$messages.agentsPanelLabel),
            testId: "sidebar-agents-button",
            isDisabled: isDisabled,
            isSelected: isOpen,
            interactionName: "open-agents-panel"
        })), [
        formatMessage,
        handleOpen,
        isDisabled,
        isOpen
    ]);
    // cloudId is required for the agents API — render nothing if unavailable.
    // This check must come after all hooks to comply with React Rules of Hooks.
    if (!cloudId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "left-start",
        content: renderContent,
        trigger: renderTrigger
    }));
};
function $8b71c15dff7ca961$var$_temp(prev) {
    return !prev;
}
module.exports["AgentsPanelButton"] = $8b71c15dff7ca961$export$2a2cb0aba834a686;

});

parcelRegister("fa8WQ", function(module, exports) {

var $gtQgC = parcelRequire("gtQgC");


var $2J4Io = parcelRequire("2J4Io");

const $7a5b39f110eb7e66$var$STUDIO_PROD_URL = 'https://studio.atlassian.com';
const $7a5b39f110eb7e66$var$STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $7a5b39f110eb7e66$export$72eb188ed9591973 = ()=>{
    return (0, $2J4Io.isStaging)() ? $7a5b39f110eb7e66$var$STUDIO_STAGING_URL : $7a5b39f110eb7e66$var$STUDIO_PROD_URL;
};
const $7a5b39f110eb7e66$var$getStudioEnv = ()=>(0, $2J4Io.isStaging)() ? 'staging' : 'production';
const $7a5b39f110eb7e66$export$372c8de5c124bdc8 = (path, email)=>{
    if (email) return (0, $gtQgC.getStudioSessionSyncUrl)($7a5b39f110eb7e66$var$getStudioEnv(), path, email);
    return `${$7a5b39f110eb7e66$export$72eb188ed9591973()}${path}`;
};
const $7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl = (workspaceId, spaceId, ruleIdUuid)=>{
    const base = `/w/${workspaceId}/spaces/${spaceId}/automation#`;
    return `${base}/rule/${encodeURIComponent(ruleIdUuid)}`;
};
const $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a = (siteId, navigationSource, csid, email, starterText)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', navigationSource);
    if (csid) searchParams.set('csid', csid);
    if (starterText) searchParams.set('starterText', starterText);
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/chat${searchParams.size > 0 ? `?${searchParams}` : ''}`, email);
};
const $7a5b39f110eb7e66$export$fe475324c26e3007 = (siteId, email)=>{
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/overview`, email);
};
const $7a5b39f110eb7e66$export$ef221a159d6fa3e8 = (siteId, agentId, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`, email);
const $7a5b39f110eb7e66$export$a20abb994c34f0a4 = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/:agentId/overview')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$3da6a4b7798ba40b = (siteId, agentAri, navigationSource, email)=>{
    const sourceParam = navigationSource ? `?navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/details${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$36c11ab884b7b2cb = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/create')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$c2d162390af7b91d = (siteId, agentAri, navigationSource, email)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', encodeURIComponent(navigationSource));
    const query = searchParams.size > 0 ? `?${searchParams}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/permissions${query}`, email);
};
const $7a5b39f110eb7e66$export$bae72ef7f23dbede = (workspaceId, spaceId, ruleIdUuid, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8($7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl(workspaceId, spaceId, ruleIdUuid), email);
module.exports["getStudioHost"] = $7a5b39f110eb7e66$export$72eb188ed9591973;
module.exports["getStudioPath"] = $7a5b39f110eb7e66$export$372c8de5c124bdc8;
module.exports["getAtlassianStudioNLCreateUrl"] = $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a;
module.exports["getAtlassianStudioAgentEditUrl"] = $7a5b39f110eb7e66$export$a20abb994c34f0a4;
module.exports["getAtlassianStudioAgentEditUrlWithAri"] = $7a5b39f110eb7e66$export$3da6a4b7798ba40b;
module.exports["getAtlassianStudioAgentDuplicateUrl"] = $7a5b39f110eb7e66$export$36c11ab884b7b2cb;
module.exports["getAtlassianStudioAutomationRuleEditUrl"] = $7a5b39f110eb7e66$export$bae72ef7f23dbede;

});

parcelRegister("gtQgC", function(module, exports) {

var $62APY = parcelRequire("62APY");

const $1665c8ad23657fd1$var$getStudioHost = (env)=>env === 'staging' ? (0, $62APY.STUDIO_STAGING_URL) : (0, $62APY.STUDIO_PROD_URL);
const $1665c8ad23657fd1$export$b4a3ce4b99911063 = (env, path, email)=>{
    const studioHost = $1665c8ad23657fd1$var$getStudioHost(env);
    const normalizedPath = path ? path.startsWith('/') ? path : `/${path}` : '';
    const destination = `${studioHost}${normalizedPath}`;
    if (!email) return destination;
    // Merge login_hint into any existing query string.
    const url = new URL(destination);
    url.searchParams.set('login_hint', email);
    return url.toString();
};
module.exports["getStudioSessionSyncUrl"] = $1665c8ad23657fd1$export$b4a3ce4b99911063;

});

parcelRegister("62APY", function(module, exports) {
const $e6043006edffc91a$export$83a42cd6c4b5f72d = 'https://studio.atlassian.com';
const $e6043006edffc91a$export$1b2ea4d616a1810d = 'https://studio.stg.atlassian.com';
module.exports["STUDIO_PROD_URL"] = $e6043006edffc91a$export$83a42cd6c4b5f72d;
module.exports["STUDIO_STAGING_URL"] = $e6043006edffc91a$export$1b2ea4d616a1810d;

});

parcelRegister("eP6A1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hq9Cp = parcelRequire("hq9Cp");


var $6gGPb = parcelRequire("6gGPb");


var $ji12t = parcelRequire("ji12t");

const $0bc982fcc00bec10$export$840bfed76f04079b = ({ recommendedAgents: recommendedAgents, agentsByCategoryAllAgents: agentsByCategoryAllAgents, agentsByCategoryFavoriteAgents: agentsByCategoryFavoriteAgents, agentsByCategoryVerifiedAgents: agentsByCategoryVerifiedAgents = [], selectedAgent: selectedAgent, moveSelectedAgentToTop: moveSelectedAgentToTop = true, defaultAgents: defaultAgents = [] })=>{
    const allAgents = [
        ...defaultAgents,
        ...agentsByCategoryFavoriteAgents,
        ...agentsByCategoryVerifiedAgents,
        ...recommendedAgents,
        ...agentsByCategoryAllAgents
    ];
    const seenAgentIds = new Set();
    const allAgentsDeduplicated = allAgents.filter((agent)=>{
        if (seenAgentIds.has(agent.id)) return false;
        seenAgentIds.add(agent.id);
        return true;
    });
    // ensure that the selected agent is at the top of the list
    if (selectedAgent && !selectedAgent.is_default) {
        const index = allAgentsDeduplicated.findIndex((agent)=>agent.id === selectedAgent.id);
        if (moveSelectedAgentToTop) {
            if (index !== -1) allAgentsDeduplicated.splice(index, 1);
            allAgentsDeduplicated.unshift(selectedAgent);
        } else if (index === -1) allAgentsDeduplicated.unshift(selectedAgent);
    }
    return allAgentsDeduplicated;
};
const $0bc982fcc00bec10$export$5fc049a7e27256a7 = (agent)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        UNSAFE_useAdsAvatar: (0, $iDrrr.fg)('platform-dst-avatar-updated-geometry'),
        size: "small",
        agentId: agent.id,
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentIdentityAccountId: agent.identity_account_id,
        showBorder: false,
        isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent),
        forgeAgentIconUrl: agent.icon
    });
};
module.exports["getDisplayedAgents"] = $0bc982fcc00bec10$export$840bfed76f04079b;
module.exports["getAgentIcon"] = $0bc982fcc00bec10$export$5fc049a7e27256a7;

});

parcelRegister("87k0g", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4nIKB = parcelRequire("4nIKB");


var $w6R6I = parcelRequire("w6R6I");


var $aRvnq = parcelRequire("aRvnq");


var $eh6Ml = parcelRequire("eh6Ml");


var $V3JOP = parcelRequire("V3JOP");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $eeCk7 = parcelRequire("eeCk7");


var $lpNn5 = parcelRequire("lpNn5");


var $4XF4G = parcelRequire("4XF4G");


var $dftWP = parcelRequire("dftWP");


var $bJ1N3 = parcelRequire("bJ1N3");

const $c1f98b070c09a977$var$styles = {
    menuItem: "_2mHwu8gVvo _0bjKvDKTcp _39xV02N91d _3iDTPbQ4SZ _0aFT5v1qpb _4kiQYAUofl _37wbyuI7V3 _0hPCNLDIqT _0wOv4Q7zJH _0KLXru66of _3gzVzLN4oS",
    menuItemActive: "_0KLXruY9q9 _1UtDYzjTy9",
    menuItemHover: "_1eOmH6o126",
    menuItemFocused: "_0KLXruo126",
    menuItemDisabled: "_0wOv4Qsyl5 _1UtDYzot27 _1YKVNsVx3j",
    menuItemContent: "_2mHwu8gVvo _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    menuItemIcon: "_3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    menuItemLabelContainer: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _2fwxA5ecOK _3YEZNO7dHp",
    labelAndVerifiedContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    menuItemLabel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d _1ANEUSLRg7 _39HuIbz8Lp",
    favoriteIconContainer: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _1Znuxb1Y8M _0wOv4Q7zJH _0KLXrujOvk _1eOmH6KcZT _3gzVzLnpTK",
    favoriteIconHidden: "_1YKVNsdnbC _30D6Ku7dHp"
};
const $c1f98b070c09a977$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function MenuItem({ label: label, icon: icon, isVerified: isVerified, onClick: onClick, isActive: isActive, isFocused: isFocused, isFavorite: isFavorite, onFavoriteClick: onFavoriteClick, isLoading: isLoading, isDisabled: isDisabled, tooltip: tooltip, interactionName: interactionName, isExternalLink: isExternalLink, ariaHasPopup: ariaHasPopup, ariaCurrent: ariaCurrent, isSubMenu: isSubMenu, labelColor: labelColor, testId: testId, componentName: componentName }, ref) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showExternalLinkIcon, setShowExternalLinkIcon] = (0, $cozmU.useState)(false);
    const [showSubMenuIcon, setShowSubMenuIcon] = (0, $cozmU.useState)(false);
    const [showFavoriteIcon, setShowFavoriteIcon] = (0, $cozmU.useState)(false);
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    const textRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (textRef.current && containerRef.current) {
                const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };
        checkOverflow();
        const resizeObserver = new ResizeObserver(checkOverflow);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        label
    ]);
    const handleOnMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (isExternalLink) setShowExternalLinkIcon(true);
        if (isSubMenu) setShowSubMenuIcon(true);
        if (onFavoriteClick !== undefined) setShowFavoriteIcon(true);
    }, [
        isExternalLink,
        isSubMenu,
        onFavoriteClick
    ]);
    const handleOnMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (isExternalLink) setShowExternalLinkIcon(false);
        if (isSubMenu) setShowSubMenuIcon(false);
        if (onFavoriteClick !== undefined) setShowFavoriteIcon(false);
    }, [
        isExternalLink,
        isSubMenu,
        onFavoriteClick
    ]);
    const handleFavoriteClick = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        onFavoriteClick?.();
    }, [
        onFavoriteClick
    ]);
    const renderMenuItem = (tooltipProps = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...tooltipProps,
            // the forwarded ref is dropped whenever `tooltip` is set. Both need to apply. Gate off
            // keeps the tooltip's ref winning — with render-prop children it is the only writer of
            // Tooltip's `targetRef`, so falling back to `ref` alone would leave Tooltip unanchored.
            ref: (0, $iDrrr.fg)('platform-dst-top-layer-tooltip') ? (0, $4nIKB.mergeRefs)([
                ref,
                tooltipProps.ref ?? null
            ]) : tooltipProps.ref ?? ref,
            xcss: (0, $w6R6I.cx)($c1f98b070c09a977$var$styles.menuItem, isActive && $c1f98b070c09a977$var$styles.menuItemActive, // if is focus is defined combobox is controlling hover styles
            isFocused === undefined && $c1f98b070c09a977$var$styles.menuItemHover, isFocused && $c1f98b070c09a977$var$styles.menuItemFocused, isDisabled && $c1f98b070c09a977$var$styles.menuItemDisabled),
            onClick: isDisabled ? undefined : onClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            "aria-disabled": isDisabled,
            "aria-haspopup": ariaHasPopup,
            "aria-current": ariaCurrent,
            testId: testId || 'menu-item-container',
            interactionName: interactionName,
            componentName: componentName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemContent,
            testId: "menu-item-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemIcon
        }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), {
            size: "small",
            testId: "loading-state"
        }) : isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(icon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(icon, {
            color: "var(--ds-icon-selected, #1868DB)"
        }) : icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            gap: "space.075",
            xcss: $c1f98b070c09a977$var$styles.labelAndVerifiedContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemLabelContainer,
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4XF4G.ConditionalTooltip), {
            withTooltip: showTooltip && !tooltip,
            content: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c1f98b070c09a977$var$styles.menuItemLabel,
            ref: textRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: labelColor ? labelColor : isActive ? 'color.text.selected' : 'color.text.subtle',
            testId: "menu-item-label"
        }, label)))), isVerified && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eeCk7.AgentVerifiedIcon), null)), isExternalLink && showExternalLinkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: "link-external",
            color: "var(--ds-icon-subtle, #505258)"
        }), isSubMenu && showSubMenuIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })), isFavorite !== undefined && onFavoriteClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($c1f98b070c09a977$var$styles.favoriteIconContainer, !isFavorite && !showFavoriteIcon && $c1f98b070c09a977$var$styles.favoriteIconHidden),
            onClick: handleFavoriteClick,
            testId: "favorite-icon-container",
            "aria-label": isFavorite ? formatMessage((0, $bJ1N3.default).removeFromFavouritesLabel, {
                agentName: label
            }) : formatMessage((0, $bJ1N3.default).addToFavouritesLabel, {
                agentName: label
            })
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
            label: "",
            color: "var(--ds-icon-warning, #E06C00)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "checkmark"
        }));
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltip
    }, renderMenuItem) : renderMenuItem();
});
module.exports["MenuItem"] = $c1f98b070c09a977$export$2ce376c2cc3355c8;

});

parcelRegister("eeCk7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $d2UzA = parcelRequire("d2UzA");


var $4ez2K = parcelRequire("4ez2K");


var $lpNn5 = parcelRequire("lpNn5");


var $dkicA = parcelRequire("dkicA");

const $f27e3d0b11cfb100$var$styles = {
    body: "_0jFU0VSPN1",
    textLarge: "_0jFU0VoWWg",
    headingMedium: "_0jFU0VoWWg",
    headingLarge: "_0jFU0VcM5X"
};
const $f27e3d0b11cfb100$export$842eb53a513553a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { adjacentTextSize: t1 } = t0;
    const adjacentTextSize = t1 === undefined ? "body" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $dkicA.default).verifiedAgentTooltip);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = adjacentTextSize === "body" && $f27e3d0b11cfb100$var$styles.body;
    const t4 = adjacentTextSize === "headingMedium" && $f27e3d0b11cfb100$var$styles.headingMedium;
    const t5 = adjacentTextSize === "headingLarge" && $f27e3d0b11cfb100$var$styles.headingLarge;
    const t6 = adjacentTextSize === "textLarge" && $f27e3d0b11cfb100$var$styles.textLarge;
    let t7;
    if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
        t7 = (0, $w6R6I.cx)(t3, t4, t5, t6);
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== formatMessage) {
        t8 = formatMessage((0, $dkicA.default).verifiedIconLabel);
        $[7] = formatMessage;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: t8,
            size: "small"
        });
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== t7 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center",
            xcss: t7
        }, t9);
        $[11] = t7;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== t10 || $[15] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t2
        }, t10);
        $[14] = t10;
        $[15] = t2;
        $[16] = t11;
    } else t11 = $[16];
    return t11;
} : ({ adjacentTextSize: adjacentTextSize = 'body' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $dkicA.default).verifiedAgentTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center",
        alignItems: "center",
        xcss: (0, $w6R6I.cx)(adjacentTextSize === 'body' && $f27e3d0b11cfb100$var$styles['body'], adjacentTextSize === 'headingMedium' && $f27e3d0b11cfb100$var$styles['headingMedium'], adjacentTextSize === 'headingLarge' && $f27e3d0b11cfb100$var$styles['headingLarge'], adjacentTextSize === 'textLarge' && $f27e3d0b11cfb100$var$styles['textLarge'])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        label: formatMessage((0, $dkicA.default).verifiedIconLabel),
        size: "small"
    })));
};
module.exports["AgentVerifiedIcon"] = $f27e3d0b11cfb100$export$842eb53a513553a2;

});

parcelRegister("dkicA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b2e8fd9d19600fe4$var$_default_1 = (0, $kSwu1.defineMessages)({
    verifiedAgentTooltip: {
        id: "agent-studio-ui-components.agent-verified.tooltip",
        defaultMessage: "This agent has been verified by your organization."
    },
    verifiedIconLabel: {
        id: "agent-studio-ui-components.agent-verified.label",
        defaultMessage: "Agent verified"
    }
});
var $b2e8fd9d19600fe4$export$2e2bcd8739ae039 = $b2e8fd9d19600fe4$var$_default_1;
module.exports["default"] = $b2e8fd9d19600fe4$export$2e2bcd8739ae039;

});

parcelRegister("bJ1N3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9cb2ee457af46ff0$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "ai-mate.menu-item.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    addToFavouritesLabel: {
        id: "ai-mate.menu-item.add-to-favourites-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $9cb2ee457af46ff0$export$2e2bcd8739ae039 = $9cb2ee457af46ff0$var$message;
module.exports["default"] = $9cb2ee457af46ff0$export$2e2bcd8739ae039;

});

parcelRegister("jW2nL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $af2Fp = parcelRequire("af2Fp");

const $cce3bab77c56367c$var$styles = {
    menuContainer: "_2mHwu8FQfX _39xV02N91d _3iDTPbccYA _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0aFT5vbt8w _0hPCNLDIqT _0KLXrulfZc",
    menuTextContainer: "_2mHwu88HPE _3iDTPbQ4SZ _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0hPCNLDIqT _4xdlr0FlnN",
    menuText: "_2sNsIgd8bj _1UtDYzKGUX",
    menuList: "_2mHwu8FQfX _1LMyvKYbGa _39xV02N91d _3iDTPbQ4SZ _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0aFT5vbt8w _0hPCNLDIqT",
    menuListItem: "_39xV02N91d _3iDTPbQ4SZ _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg"
};
const $cce3bab77c56367c$export$e3c8d6f66737f40c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { sections: sections } = t0;
    let T0;
    let t1;
    let t2;
    if ($[0] !== sections) {
        const visibleSections = sections.filter($cce3bab77c56367c$var$_temp);
        T0 = (0, $iMnC5.Box);
        t1 = $cce3bab77c56367c$var$styles.menuContainer;
        t2 = visibleSections.map((section_0, sectionIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                key: sectionIndex
            }, section_0.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cce3bab77c56367c$var$styles.menuTextContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                role: "heading",
                "aria-level": 2,
                xcss: $cce3bab77c56367c$var$styles.menuText
            }, section_0.title)), "content" in section_0 ? section_0.content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "ul",
                xcss: $cce3bab77c56367c$var$styles.menuList
            }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(section_0.items, $cce3bab77c56367c$var$_temp2)), sectionIndex !== visibleSections.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2Fp.Divider), {
                isThin: true,
                withMargin: true
            })));
        $[0] = sections;
        $[1] = T0;
        $[2] = t1;
        $[3] = t2;
    } else {
        T0 = $[1];
        t1 = $[2];
        t2 = $[3];
    }
    let t3;
    if ($[4] !== T0 || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t1
        }, t2);
        $[4] = T0;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ sections: sections })=>{
    const visibleSections = sections.filter((section)=>'content' in section ? section.content != null : section.items.length > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cce3bab77c56367c$var$styles.menuContainer
    }, visibleSections.map((section_0, sectionIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: sectionIndex
        }, section_0.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cce3bab77c56367c$var$styles.menuTextContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "heading",
            "aria-level": 2,
            xcss: $cce3bab77c56367c$var$styles.menuText
        }, section_0.title)), 'content' in section_0 ? section_0.content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $cce3bab77c56367c$var$styles.menuList
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(section_0.items, (item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "li",
                xcss: $cce3bab77c56367c$var$styles.menuListItem
            }, item))), sectionIndex !== visibleSections.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af2Fp.Divider), {
            isThin: true,
            withMargin: true
        }))));
};
function $cce3bab77c56367c$var$_temp(section) {
    return "content" in section ? section.content != null : section.items.length > 0;
}
function $cce3bab77c56367c$var$_temp2(item) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $cce3bab77c56367c$var$styles.menuListItem
    }, item);
}
module.exports["ChatHeaderMenuList"] = $cce3bab77c56367c$export$e3c8d6f66737f40c;

});

parcelRegister("af2Fp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $25b936668dcad52b$var$styles = {
    divider: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d",
    thinDivider: "_39xV02N91d _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    dividerMargin: "_3138422ADO _1DCdHi2ADO"
};
const $25b936668dcad52b$export$2e0a83ec2e27ecbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { isThin: t1, withMargin: t2 } = t0;
    const isThin = t1 === undefined ? false : t1;
    const withMargin = t2 === undefined ? false : t2;
    const t3 = !isThin ? $25b936668dcad52b$var$styles.divider : $25b936668dcad52b$var$styles.thinDivider;
    const t4 = withMargin && $25b936668dcad52b$var$styles.dividerMargin;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = (0, $w6R6I.cx)(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t5,
            backgroundColor: "color.background.neutral.subtle",
            role: "separator"
        });
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    return t6;
} : ({ isThin: isThin = false, withMargin: withMargin = false })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!isThin ? $25b936668dcad52b$var$styles.divider : $25b936668dcad52b$var$styles.thinDivider, withMargin && $25b936668dcad52b$var$styles.dividerMargin),
        backgroundColor: "color.background.neutral.subtle",
        role: "separator"
    });
};
module.exports["Divider"] = $25b936668dcad52b$export$2e0a83ec2e27ecbb;

});

parcelRegister("88DFk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6CGVr = parcelRequire("6CGVr");


var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $kXiqf = parcelRequire("kXiqf");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $9d01a40d5c3361ba$var$DefaultActionSubject = 'rovoAgent';
const $9d01a40d5c3361ba$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $9d01a40d5c3361ba$export$b9dc0ab1bce924aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = (0, $kXiqf.useRovoAgentCSID)();
    const { csid: csid, globalCSID: globalCSID } = t0;
    const { refresh: refreshCSID } = t1;
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t2 = (event)=>{
            const referrer = typeof window !== "undefined" ? window.document.referrer : "unknown";
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                ...event.attributes,
                actionGroup: "createFlow",
                referrer: referrer
            };
            createAnalyticsEvent({
                ...$9d01a40d5c3361ba$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const fireAnalyticsEvent = t2;
    let t3;
    if ($[3] !== fireAnalyticsEvent || $[4] !== globalCSID) {
        t3 = (action, attributes_0)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: action,
                attributes: {
                    csid: globalCSID,
                    ...attributes_0
                }
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = globalCSID;
        $[5] = t3;
    } else t3 = $[5];
    const trackCreateSession = t3;
    let t4;
    if ($[6] !== csid || $[7] !== fireAnalyticsEvent || $[8] !== refreshCSID) {
        t4 = (attributes_1)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowStart",
                attributes: {
                    csid: csid,
                    ...attributes_1
                }
            });
            refreshCSID();
        };
        $[6] = csid;
        $[7] = fireAnalyticsEvent;
        $[8] = refreshCSID;
        $[9] = t4;
    } else t4 = $[9];
    const trackCreateSessionStart = t4;
    let t5;
    if ($[10] !== fireAnalyticsEvent || $[11] !== globalCSID) {
        t5 = (error, attributes_2)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowError",
                attributes: {
                    error: {
                        message: error.message
                    },
                    csid: globalCSID,
                    ...attributes_2
                }
            });
        };
        $[10] = fireAnalyticsEvent;
        $[11] = globalCSID;
        $[12] = t5;
    } else t5 = $[12];
    const trackCreateSessionError = t5;
    let t6;
    if ($[13] !== refreshCSID || $[14] !== trackCreateSession || $[15] !== trackCreateSessionError || $[16] !== trackCreateSessionStart) {
        t6 = {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        };
        $[13] = refreshCSID;
        $[14] = trackCreateSession;
        $[15] = trackCreateSessionError;
        $[16] = trackCreateSessionStart;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== csid || $[19] !== t6) {
        t7 = [
            csid,
            t6
        ];
        $[18] = csid;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : (commonAttributes)=>{
    const [{ csid: csid, globalCSID: globalCSID }, { refresh: refreshCSID }] = (0, $kXiqf.useRovoAgentCSID)();
    const analyticsContext = (0, $cozmU.useContext)((0, $6CGVr.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const referrer = typeof window !== 'undefined' ? window.document.referrer : 'unknown';
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            ...event.attributes,
            actionGroup: 'createFlow',
            referrer: referrer
        };
        createAnalyticsEvent({
            ...$9d01a40d5c3361ba$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fires an analytics event for a step in the create agent flow funnel.
   * Uses the CSID from the URL query parameter.
   */ const trackCreateSession = (0, $cozmU.useCallback)((action, attributes_0)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: action,
            attributes: {
                csid: globalCSID,
                ...attributes_0
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    /**
   * Fires `createFlowStart` with the current CSID (matching the href),
   * then refreshes the CSID for the next session.
   * The component re-renders with the new CSID, updating any href attributes.
   */ const trackCreateSessionStart = (0, $cozmU.useCallback)((attributes_1)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowStart',
            attributes: {
                csid: csid,
                ...attributes_1
            }
        });
        refreshCSID();
    }, [
        fireAnalyticsEvent,
        refreshCSID,
        csid
    ]);
    const trackCreateSessionError = (0, $cozmU.useCallback)((error, attributes_2)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowError',
            attributes: {
                error: {
                    message: error.message
                },
                csid: globalCSID,
                ...attributes_2
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    return [
        csid,
        {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        }
    ];
};
module.exports["useRovoAgentCreateAnalytics"] = $9d01a40d5c3361ba$export$b9dc0ab1bce924aa;

});

parcelRegister("kXiqf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $debAY = parcelRequire("debAY");

let $3de3d827eb32710a$var$CACHED_CSID = null;
const $3de3d827eb32710a$var$generateCSID = ()=>{
    return crypto.randomUUID();
};
const $3de3d827eb32710a$export$2e155615ea28a17b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID();
        $[0] = t0;
    } else t0 = $[0];
    const [csid, setCSID] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        const queryParams = new URLSearchParams(window.location.search);
        t1 = queryParams.get((0, $debAY.CSID_QUERY_PARAM));
        $[1] = t1;
    } else t1 = $[1];
    const globalCSID = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const actions = t2;
    let t3;
    if ($[3] !== csid) {
        t3 = [
            {
                csid: csid,
                globalCSID: globalCSID
            },
            actions
        ];
        $[3] = csid;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [csid, setCSID] = (0, $cozmU.useState)($3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID());
    const globalCSID = (0, $cozmU.useMemo)(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get((0, $debAY.CSID_QUERY_PARAM));
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        return {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
    }, []);
    return [
        {
            csid: csid,
            globalCSID: // generated CSID to be used in href and createFlowStart events
            globalCSID // CSID from the URL query parameter
        },
        actions
    ];
};
module.exports["useRovoAgentCSID"] = $3de3d827eb32710a$export$2e155615ea28a17b;

});

parcelRegister("debAY", function(module, exports) {
const $881ebb84c71795d2$export$61b85fb5d2d632d0 = 'csid';
module.exports["CSID_QUERY_PARAM"] = $881ebb84c71795d2$export$61b85fb5d2d632d0;

});

parcelRegister("8auAj", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $34b824decffaa688$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).NONE];
}
module.exports["isRestricted"] = $34b824decffaa688$export$dbaa15dc1820b89a;

});

parcelRegister("j1Rvl", function(module, exports) {
parcelRequire("cozmU");


var $92AHJ = parcelRequire("92AHJ");


var $7n3BL = parcelRequire("7n3BL");

const $878ccfcc8552aaa6$export$98e06fe7a6174253 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).differentText);
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("7n3BL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
module.exports["propFormatter"] = $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50;

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hI76F = parcelRequire("hI76F");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("hI76F", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $27fa02be5ce1169a$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("hqKAV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hZBvY")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("bKkYT")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("35vun")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("feSXU")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("ejFse")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ijMmr")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("3MV0X")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("iEpiF")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("ilr1n")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("g0oFy")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("2tmS1")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("37leR")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("9w6w2")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("1XXvL")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("l1Sln")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("aZHXV")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("8Ul7q")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("9nRMt")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("3VJWA")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("4150a")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("iOI3D")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("d8i36")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $27fa02be5ce1169a$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $27fa02be5ce1169a$export$d0a3169680473b6c;

});

parcelRegister("hqKAV", function(module, exports) {

let $cb090215aa1c7244$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb090215aa1c7244$var$load("1JYrd"),
    $cb090215aa1c7244$var$load("cip6w"),
    $cb090215aa1c7244$var$load("gAG2n"),
    $cb090215aa1c7244$var$load("3feYV"),
    $cb090215aa1c7244$var$load("cwjU2"),
    $cb090215aa1c7244$var$load("3Ff1R"),
    $cb090215aa1c7244$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("hZBvY", function(module, exports) {

let $d1953bd3a2974a48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d1953bd3a2974a48$var$load("30242"),
    $d1953bd3a2974a48$var$load("3qBwQ"),
    $d1953bd3a2974a48$var$load("cYGDU"),
    $d1953bd3a2974a48$var$load("7Q1SM"),
    $d1953bd3a2974a48$var$load("33Iaa"),
    $d1953bd3a2974a48$var$load("blA7x"),
    $d1953bd3a2974a48$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("bKkYT", function(module, exports) {

let $88d44407619f68d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $88d44407619f68d3$var$load("15aAJ"),
    $88d44407619f68d3$var$load("8rREG"),
    $88d44407619f68d3$var$load("dgXJL"),
    $88d44407619f68d3$var$load("7JdzX"),
    $88d44407619f68d3$var$load("6681T"),
    $88d44407619f68d3$var$load("3dn3H"),
    $88d44407619f68d3$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("35vun", function(module, exports) {

let $23fa43cac21f66f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $23fa43cac21f66f7$var$load("l5BBd"),
    $23fa43cac21f66f7$var$load("93ASN"),
    $23fa43cac21f66f7$var$load("htu5t"),
    $23fa43cac21f66f7$var$load("24LNf"),
    $23fa43cac21f66f7$var$load("iYQCc"),
    $23fa43cac21f66f7$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("feSXU", function(module, exports) {

let $b182cccc51a21da0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b182cccc51a21da0$var$load("bbv9t"),
    $b182cccc51a21da0$var$load("9fQoJ"),
    $b182cccc51a21da0$var$load("lTboH"),
    $b182cccc51a21da0$var$load("cnlNg"),
    $b182cccc51a21da0$var$load("d3Phe"),
    $b182cccc51a21da0$var$load("lASLx"),
    $b182cccc51a21da0$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("ejFse", function(module, exports) {

let $a6c2fefec1957a21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6c2fefec1957a21$var$load("7p4je"),
    $a6c2fefec1957a21$var$load("8SZbD"),
    $a6c2fefec1957a21$var$load("iE05k"),
    $a6c2fefec1957a21$var$load("9Uf61"),
    $a6c2fefec1957a21$var$load("3Yk1e"),
    $a6c2fefec1957a21$var$load("5lJyy"),
    $a6c2fefec1957a21$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("ijMmr", function(module, exports) {

let $d55f83d4930a3a37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d55f83d4930a3a37$var$load("5ZQnr"),
    $d55f83d4930a3a37$var$load("lJyww"),
    $d55f83d4930a3a37$var$load("2hqQb"),
    $d55f83d4930a3a37$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("3MV0X", function(module, exports) {

let $2c2214ae0b7fe6c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c2214ae0b7fe6c5$var$load("1jQRQ"),
    $2c2214ae0b7fe6c5$var$load("5pOQA"),
    $2c2214ae0b7fe6c5$var$load("5GSny"),
    $2c2214ae0b7fe6c5$var$load("fJSEb"),
    $2c2214ae0b7fe6c5$var$load("ajzkj"),
    $2c2214ae0b7fe6c5$var$load("eyysG"),
    $2c2214ae0b7fe6c5$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("iEpiF", function(module, exports) {

let $d93f96799db33c2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d93f96799db33c2c$var$load("km37l"),
    $d93f96799db33c2c$var$load("gbksI"),
    $d93f96799db33c2c$var$load("j2X7f"),
    $d93f96799db33c2c$var$load("9TeWr"),
    $d93f96799db33c2c$var$load("kUZ7k"),
    $d93f96799db33c2c$var$load("dJQL7"),
    $d93f96799db33c2c$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("ilr1n", function(module, exports) {

let $d5af25feeea858f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5af25feeea858f7$var$load("lTbXI"),
    $d5af25feeea858f7$var$load("a98cw"),
    $d5af25feeea858f7$var$load("e40mE"),
    $d5af25feeea858f7$var$load("fOGnR"),
    $d5af25feeea858f7$var$load("cDQOq"),
    $d5af25feeea858f7$var$load("8upye"),
    $d5af25feeea858f7$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("g0oFy", function(module, exports) {

let $ba6fc83991d24911$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ba6fc83991d24911$var$load("iUyZj"),
    $ba6fc83991d24911$var$load("4PDaO"),
    $ba6fc83991d24911$var$load("lMhbw"),
    $ba6fc83991d24911$var$load("8nEeY"),
    $ba6fc83991d24911$var$load("kLZKK"),
    $ba6fc83991d24911$var$load("c7GMc"),
    $ba6fc83991d24911$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("2tmS1", function(module, exports) {

let $1cd007cc20d329a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1cd007cc20d329a6$var$load("kPlMQ"),
    $1cd007cc20d329a6$var$load("ervs7"),
    $1cd007cc20d329a6$var$load("8CX31"),
    $1cd007cc20d329a6$var$load("fzzMQ"),
    $1cd007cc20d329a6$var$load("33S6H"),
    $1cd007cc20d329a6$var$load("kFae4"),
    $1cd007cc20d329a6$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("37leR", function(module, exports) {

let $24528016eeb341d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $24528016eeb341d6$var$load("iT2sv"),
    $24528016eeb341d6$var$load("iMMtn"),
    $24528016eeb341d6$var$load("23VWs"),
    $24528016eeb341d6$var$load("3gNEO"),
    $24528016eeb341d6$var$load("93obY"),
    $24528016eeb341d6$var$load("6Y9jE"),
    $24528016eeb341d6$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("9w6w2", function(module, exports) {

let $6edc281a2e3b62b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6edc281a2e3b62b4$var$load("lyPpF"),
    $6edc281a2e3b62b4$var$load("eX5n7"),
    $6edc281a2e3b62b4$var$load("aiYuN"),
    $6edc281a2e3b62b4$var$load("gvylW"),
    $6edc281a2e3b62b4$var$load("bxfRe"),
    $6edc281a2e3b62b4$var$load("ed6s8"),
    $6edc281a2e3b62b4$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("1XXvL", function(module, exports) {

let $16e976d9b17d9754$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $16e976d9b17d9754$var$load("iN3cj"),
    $16e976d9b17d9754$var$load("3nHdy"),
    $16e976d9b17d9754$var$load("gDEvm"),
    $16e976d9b17d9754$var$load("80OLx"),
    $16e976d9b17d9754$var$load("1EVcg"),
    $16e976d9b17d9754$var$load("96q1k"),
    $16e976d9b17d9754$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("l1Sln", function(module, exports) {

let $f4f3d883a1d74d7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f4f3d883a1d74d7d$var$load("eC1OL"),
    $f4f3d883a1d74d7d$var$load("ilL9c"),
    $f4f3d883a1d74d7d$var$load("64nco"),
    $f4f3d883a1d74d7d$var$load("e4s0V"),
    $f4f3d883a1d74d7d$var$load("28EXy"),
    $f4f3d883a1d74d7d$var$load("7RZp5"),
    $f4f3d883a1d74d7d$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("aZHXV", function(module, exports) {

let $8011b48931b826fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8011b48931b826fd$var$load("4NJ49"),
    $8011b48931b826fd$var$load("bfOZL"),
    $8011b48931b826fd$var$load("jLbRX"),
    $8011b48931b826fd$var$load("4dPO1"),
    $8011b48931b826fd$var$load("gg8tK"),
    $8011b48931b826fd$var$load("eF54W"),
    $8011b48931b826fd$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("8Ul7q", function(module, exports) {

let $67c3ef6c1d579887$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67c3ef6c1d579887$var$load("fsCDU"),
    $67c3ef6c1d579887$var$load("kuolm"),
    $67c3ef6c1d579887$var$load("apVmx"),
    $67c3ef6c1d579887$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("9nRMt", function(module, exports) {

let $6d4ffacd299246a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d4ffacd299246a9$var$load("g9gkE"),
    $6d4ffacd299246a9$var$load("jYdbS"),
    $6d4ffacd299246a9$var$load("6ncWv"),
    $6d4ffacd299246a9$var$load("ltrgi"),
    $6d4ffacd299246a9$var$load("fu25G"),
    $6d4ffacd299246a9$var$load("iQGcz"),
    $6d4ffacd299246a9$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("3VJWA", function(module, exports) {

let $2dca557ccc009e9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2dca557ccc009e9d$var$load("jhikU"),
    $2dca557ccc009e9d$var$load("f0i3H"),
    $2dca557ccc009e9d$var$load("bvBAp"),
    $2dca557ccc009e9d$var$load("69YlM"),
    $2dca557ccc009e9d$var$load("cyTsc"),
    $2dca557ccc009e9d$var$load("kXCsp"),
    $2dca557ccc009e9d$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("4150a", function(module, exports) {

let $2ecb22ac2e9ca9a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2ecb22ac2e9ca9a4$var$load("fSsz4"),
    $2ecb22ac2e9ca9a4$var$load("kWOpS"),
    $2ecb22ac2e9ca9a4$var$load("9tUAi"),
    $2ecb22ac2e9ca9a4$var$load("kgHzZ"),
    $2ecb22ac2e9ca9a4$var$load("j4ur8"),
    $2ecb22ac2e9ca9a4$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("iOI3D", function(module, exports) {

let $db2f12754626290c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db2f12754626290c$var$load("d91RK"),
    $db2f12754626290c$var$load("f7hfJ"),
    $db2f12754626290c$var$load("QI1kr"),
    $db2f12754626290c$var$load("brdRT"),
    $db2f12754626290c$var$load("lWBlc"),
    $db2f12754626290c$var$load("s2EmI"),
    $db2f12754626290c$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("d8i36", function(module, exports) {

let $98fa05e5383d8189$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $98fa05e5383d8189$var$load("708J7"),
    $98fa05e5383d8189$var$load("kVqUf"),
    $98fa05e5383d8189$var$load("2IMxh"),
    $98fa05e5383d8189$var$load("j03Pa"),
    $98fa05e5383d8189$var$load("kke1I"),
    $98fa05e5383d8189$var$load("gOwMq"),
    $98fa05e5383d8189$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("jrbLf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $9ff69d9ac960dda9$export$2cab3982d83485b0 = /*#__PURE__*/ (0, $cozmU.createContext)({
    siteId: ''
});
const $9ff69d9ac960dda9$export$55c0e3cb4fbc46cf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($9ff69d9ac960dda9$export$2cab3982d83485b0);
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($9ff69d9ac960dda9$export$2cab3982d83485b0);
    return context;
};
module.exports["SiteContext"] = $9ff69d9ac960dda9$export$2cab3982d83485b0;
module.exports["useSiteContext"] = $9ff69d9ac960dda9$export$55c0e3cb4fbc46cf;

});


//# sourceMappingURL=AgentsPanelButton.0717b201.js.map
